import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  padding: 5rem 1rem;
  background: var(--background-dark);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

const Media = styled.div`
  border-radius: 1.5rem;
  overflow: hidden;
  border: 1px solid rgba(0, 153, 0, 0.25);
  aspect-ratio: 4/3;
  img { width: 100%; height: 100%; object-fit: cover; display: block; }
`;

const Copy = styled.div`
  color: var(--text-color);

  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0, 153, 0, 0.08);
    color: var(--primary-color);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 {
    font-size: clamp(1.75rem, 3.2vw, 2.5rem);
    margin: 0 0 1rem;
    span { color: var(--primary-color); }
  }
  .lede {
    color: var(--text-secondary);
    line-height: 1.7;
    margin: 0 0 2rem;
  }
`;

const Step = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.25rem;

  .num {
    flex: 0 0 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(0, 153, 0, 0.12);
    color: var(--primary-color);
    font-weight: 800;
    font-size: 1.1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  h3 { margin: 0 0 0.25rem; font-size: 1.05rem; color: var(--text-color); }
  p { margin: 0; color: var(--text-secondary); line-height: 1.55; font-size: 0.95rem; }
`;

const HowItWorksNew: React.FC = () => (
  <Section id="how-it-works">
    <Inner>
      <Media>
        <img src="/img/otc-trading.jpeg" alt="USDT flashing across TRC-20, ERC-20 and BEP-20 networks" />
      </Media>
      <Copy>
        <div className="tag">How it works</div>
        <h2>From license key to first flash in <span>under 5 minutes</span></h2>
        <p className="lede">
          The software runs on Windows, macOS, and Android. Choose a plan, receive
          your key by email, and start creating realistic USDT balances on the
          network you pick.
        </p>
        <Step>
          <span className="num">1</span>
          <div>
            <h3>Buy a license</h3>
            <p>Pick a tier that matches your daily flash volume. Pay via BTC or USDT — the license and download link arrive by email within minutes.</p>
          </div>
        </Step>
        <Step>
          <span className="num">2</span>
          <div>
            <h3>Install &amp; activate</h3>
            <p>Install on your device, paste the license key. Support is on WhatsApp 24/7 if activation asks for anything unusual.</p>
          </div>
        </Step>
        <Step>
          <span className="num">3</span>
          <div>
            <h3>Flash on any supported network</h3>
            <p>Pick TRC-20, ERC-20, or BEP-20. Enter the recipient address and amount. The balance appears on supported wallets and explorers.</p>
          </div>
        </Step>
      </Copy>
    </Inner>
  </Section>
);

export default HowItWorksNew;
